import { useEchoPublic } from '@laravel/echo-vue'

import { useAppStore } from '@/store/appStore'

import { ECHO_CHANNELS } from '@/constants/echoChannels'

export function useMaintenanceChannel() {
    const appStore = useAppStore()

    useEchoPublic(
        ECHO_CHANNELS.maintenanceMode(),
        '.application.maintenance-mode-event',
        (payload) => {
            appStore.setMaintenanceMode(payload.data)
        },
    )
}
